export default "__VITE_ASSET__B47M2cxz__"